import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

import s from './THead.module.scss';

type Props = {
  className?: string;
};

const THead: React.FC<PropsWithChildren<Props>> = ({ children, className }) => (
  <thead className={classNames(s.sticky, className)}>{children}</thead>
);

export default THead;
